import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {BootstrapServiceBase} from '@app/bootstrap.service.base';
import {AbstractPlatform} from '@app/platform/platform';
import {ControllerClientServiceBase} from '@app/shared/controller-client.service.base';
import {TimeService} from '@app/shared/time.service';
import {SettingsService} from '@app/sync/settings.service';
import {SyncServiceBase} from '@app/sync/sync.service.base';

@Injectable()
export class BootstrapService extends BootstrapServiceBase {

    constructor(
        sync: SyncServiceBase,
        settings: SettingsService,
        platform: AbstractPlatform,
        time: TimeService,
        controllerClient: ControllerClientServiceBase,
        private readonly router: Router,
    ) {
        super(sync, settings, platform, time, controllerClient);
    }

    async bootstrap(): Promise<void> {
        await super.bootstrap();
        this.logger.debug('Executing bootstrap.service.lite.ts:bootstrap()');
        await this.router.navigate(['sync']);
    }

    async onAfterFirstSync(): Promise<void> {
        await super.onAfterFirstSync();
    }

    async onConfigDownloaded(): Promise<void> {
        return;
    }
}
